import * as React from 'react';

import styles from './styles.less';

export const RecalculationWarning: React.FunctionComponent<React.PropsWithChildren<unknown>> = () => {
	return (
		<p className={styles.parametersWarning}>
			By default, Price Monitor recalculates prices in align with the AIFP. If you want to use the official SK MOH
			methodology, please select the option “MZSR metodika”.
		</p>
	);
};
